import { useEffect, useRef } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const IntercomButton = (props) => {

    const INTERCOM_APP_ID = props.IntercomAppID;
    const windowSize = useWindowSize();
    const originalRightRef = useRef(null);
    const originalBottomRef = useRef(null);

    useEffect(() => {
        if (INTERCOM_APP_ID) {
            (function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();

            if (props.IsAuthenticated) {
                window.Intercom("boot", {
                    api_base: "https://api-iam.intercom.io",
                    app_id: INTERCOM_APP_ID,
                    name: props.IntercomUser,
                    email: props.IntercomEmail,
                    user_id: props.IntercomUserID,
                    bidder_number: props.BidderNumber
                });
                                   
            } else {
                window.Intercom("boot", {
                    api_base: "https://api-iam.intercom.io",
                    app_id: INTERCOM_APP_ID,
                });
            }

            const handlePageHide = () => { 
                if (props.IsAuthenticated) {
                    Intercom('shutdown');
                }
            };

            window.addEventListener('pagehide', handlePageHide);
            
            return () => {
                window.removeEventListener('pagehide', handlePageHide);
            };
        }
    }, []);

    useEffect(() => {
        const adjustPosition = () => {
            let intercom = document.getElementsByClassName('intercom-launcher')[0];
            if (!intercom) {
                intercom = document.querySelector('[class*="intercom-with-namespace-"]:not(.intercom-messenger-frame)');
            }
            if (intercom) {
                let hasListingControlBar = document.getElementsByClassName('mobile-listing-control-bar').length > 0;
                let hasMobileOptionBar = document.getElementsByClassName('mobile-option-bar').length > 0;
                let hasDetailsContactBar = document.getElementsByClassName('detail-contact-bar').length > 0;

                if (originalRightRef.current === null) {
                    originalRightRef.current = intercom.style.right;
                }
                if (originalBottomRef.current === null) {
                    originalBottomRef.current = intercom.style.bottom;
                }

                intercom.style.right = originalRightRef.current;
                intercom.style.bottom = originalBottomRef.current;

                if (hasMobileOptionBar || hasDetailsContactBar) {
                    intercom.style.bottom = '75px';
                }

                if (hasListingControlBar && windowSize.width < 660) {
                    const listingControlBar = document.getElementsByClassName('mobile-listing-control-bar')[0].getBoundingClientRect();

                    if (listingControlBar.height > 60) {
                        intercom.style.bottom = '89px';
                    }
                    else {
                        intercom.style.bottom = '56px';
                    }

                    const intercomRect = intercom.getBoundingClientRect();
                    if (listingControlBar.top < intercomRect.bottom) {
                        intercom.style.bottom = '20px';
                    }
                }
            }
        };

        adjustPosition();

        const observer = new MutationObserver(adjustPosition);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [windowSize.width]);

    return <></>;
};

export default IntercomButton;

